import { useContext } from "react";
import Flex from "../../Tools/Flex";
import Kpi from "../../Tools/Kpi";
import UserContext from "../../../services/Context/UserContext";

export default function Stats({activities}){

    const {user} = useContext(UserContext)

    const color = user.category?.color

    const deals = activities.filter(a => a.type.id === 'deal');

    const won = deals.filter(d => d.won).length;

    const count = deals.map(d => d.winsCount).reduce((a,b) => a + b, 0);

    const turnover = deals.map(d => d.winsAmount).reduce((a,b) => a + b, 0);

    //const revenue = turnover * 0.01;

    const ratio = deals.length ? Math.round(won / deals.length * 100) : 0;

    const sx = {mr: 1, mb: 1};

    return <Flex sx={{mb: 2}}>

        <Kpi 
            title={won.toLocaleString()}
            caption='Affaires gagnées'
            icon='handshake'
            sx={sx}
            color={color}
        />
        
        <Kpi 
            title={count.toLocaleString()}
            caption='Ventes générées'
            icon='win'
            sx={sx}
            color={color}
        />

        <Kpi 
            title={turnover.toLocaleString() + ' €'}
            caption="Revenus générés"
            icon='pig'
            sx={sx}
            color={color}
        />

        <Kpi 
            title={ratio + ' %'}
            caption="Taux de réussite"
            icon='gaugue'
            sx={sx}
            color={color}
        />

    </Flex>
}

